import { statusTokens } from "../domain/status";
import type { CompanyStatus } from "../domain/status";
import { nl } from "../i18n/nl";
import { CompanyAvatar } from "./CompanyAvatar";
import styles from "./CompanyRow.module.css";

export interface CompanyRowData {
  id: string;
  name: string;
  status: CompanyStatus;
  hue?: number;
  /** e.g. "IT extern beheerd" or "Gemeente Geel"; shown after the status. */
  detail?: string;
  /** Relative time, already formatted ("3 dagen geleden"). */
  updated?: string;
  /** "Jouw claim", "Wachtlijst", "Gevolgd". */
  tag?: string;
}

export interface CompanyRowProps {
  company: CompanyRowData;
  selected?: boolean;
  onSelect?: (id: string) => void;
}

/** List row: avatar | name + "Status · detail" | time + tag. Selection = tint + ink bar. */
export function CompanyRow({ company, selected = false, onSelect }: CompanyRowProps) {
  const { id, name, status, hue, detail, updated, tag } = company;
  const statusLabel = nl.status[status];
  return (
    <button
      type="button"
      className={[styles.row, selected && styles.selected].filter(Boolean).join(" ")}
      aria-current={selected ? "true" : undefined}
      onClick={() => onSelect?.(id)}
    >
      <CompanyAvatar id={id} name={name} hue={hue} status={status} />
      <span className={styles.main}>
        <span className={styles.name}>{name}</span>
        <span className={styles.meta}>
          <span className={styles.status} style={{ color: statusTokens(status).fg }}>
            {statusLabel}
          </span>
          {detail && <> · {detail}</>}
        </span>
      </span>
      <span className={styles.aside}>
        {updated && <span className={styles.updated}>{updated}</span>}
        {tag && <span className={styles.tag}>{tag}</span>}
      </span>
    </button>
  );
}
